<template>
  <div class="coupon">
    <div class="order-nav">
      <Nav
        :list="navList"
        :activeValue.sync="activeValue"
        @on-success="onNavChange"
        class="channel-nav-container"
      ></Nav>
      <el-popover title="领券中心 Coupon" width="300" trigger="hover">
        <el-image :src="appletCodeImg"></el-image>
        <div class="qrcode" slot="reference">
          <el-image :src="appletCodeImg"></el-image>
        </div>
      </el-popover>
    </div>
    <TablePage ref="list" @page-change="pageHandler" :total="total" :pageSizeNum="6">
      <div class="coupon-list">
        <CouponPanel @click.native="chooseItem(item)" v-for="item in list" :item="item" :key="item.id" />
      </div>
    </TablePage>
    <CouponDialog v-if="couponVisible" :visible.sync="couponVisible" title="券详情 Coupon details" :info="info" />
  </div>
</template>

<script>
import Nav from "@/components/base/Nav.vue";
import TablePage from "@/components/base/TablePage";
import CouponPanel from "@/components/base/CouponPanel";
import CouponDialog from "./components/CouponDialog";
export default {
  name: "coupon",
  components: { Nav, TablePage, CouponPanel, CouponDialog },
  data() {
    return {
      navList: [
        {
          label: "待使用",
          labelEn: "Unused",
          value: 0,
        },
        {
          label: "已使用/已过期",
          labelEn: "Used/expired",
          value: 1,
        },
      ],
      activeValue: 0,
      total: 0,
      list: [],
      info: {},
      couponVisible: false,
      appletCodeImg: "",
    };
  },
  computed: {},
  async mounted() {
    this.searchHandler();
    this.getAppletCode();
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    onNavChange() {
      this.searchHandler();
    },
    chooseItem(item) {
      this.info = item;
      console.log('item-----',item)
      this.info.couponDesc = (this.info.couponDesc || '').replace(/img/g, 'img class="descClauseImg"');;
      this.couponVisible = true;
    },
    //获取小程序码
    async getAppletCode() {
      const params = {
        page: `implant/couponMall/index`,
        scene: `couponMall`,
      };
      try {
        let { data } = await this.$api.getQrCode(params);
        this.appletCodeImg = data;
      } catch (error) {
        console.log(error);
      }
    },

    //查询数据
    async pageHandler(page, pageSize) {
      const params = {
        page: page,
        pageSize: pageSize,
        statusList: this.activeValue == 0 ? [2] : [3, 4],
      };
      try {
        const {
          data: { list, total },
        } = await this.$api.getCouponListForC(params);
        this.list = list || [];
        this.total = total;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon {
  overflow: hidden;
  /deep/ .channel-nav-item {
    font-size: 14px;
  }
  .order-nav {
    margin-top: 60px;
    padding-left: 40px;
    display: flex;
    justify-content: space-between;
    .channel-nav-container {
      flex: 1;
    }
    .qrcode {
      width: 40px;
      height: 40px;
      margin-right: 40px;
    }
  }
  .coupon-list {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-top: 22px;
    margin-left: 55px;
    overflow-y: auto;
    .coupon-item {
      width: 30%;
    }
  }
}
</style>
